import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useScrollRestoration } from '../hooks/useScrollRestoration';
import Header from './Header';
import Hero from './Hero';
import Welcome from './Welcome';
import Services from './Services';
import WhyChooseUs from './WhyChooseUs';
import OurExperts from './OurExperts';
import Testimonials from './Testimonials';
import Footer from './Footer';
import ScheduleModal from './ScheduleModal';

const MainPage = () => {
  const [isScheduleModalOpen, setIsScheduleModalOpen] = useState(false);
  const navigate = useNavigate();
  const { saveScrollPosition } = useScrollRestoration();

  const openContactModal = () => {
    saveScrollPosition();
    navigate('/contact');
  };

  const openScheduleModal = () => {
    // setIsScheduleModalOpen(true);
    saveScrollPosition();
    navigate('/contact');
  };

  const closeScheduleModal = () => {
    setIsScheduleModalOpen(false);
  };

  const openProcedureModal = (procedure) => {
    // Save current scroll position before navigating
    saveScrollPosition();
    
    const procedureSlug = procedure.title.toLowerCase().replace(/\s+/g, '-');
    navigate(`/procedure/${procedureSlug}`, { state: { procedure } });
  };

  return (
    <>
      <Header onContactClick={openContactModal} />
      <Hero onContactClick={openContactModal} onScheduleClick={openScheduleModal} />
      <Services onProcedureClick={openProcedureModal} />
      <Welcome />
      <WhyChooseUs />
      <OurExperts />
      <Testimonials />
      <Footer />
      <ScheduleModal isOpen={isScheduleModalOpen} onClose={closeScheduleModal} />
    </>
  );
};

export default MainPage;